import React from 'react';

import Icon from '../Icon/Icon';

const InfoIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                d='M24 7C33.3888 7 41 14.6112 41 24C41 33.3888 33.3888 41 24 41C14.6112 41 7 33.3888 7 24C7 14.6112 14.6112 7 24 7Z'
                fill='#393E44'
                stroke='#00D1D2'
                strokeWidth='2'
            />
            <path
                d='M25.1566 26.6844C25.1391 27.2779 24.653 27.75 24.0592 27.75C23.4697 27.75 22.9854 27.2845 22.9622 26.6955L22.5597 16.5064C22.5273 15.6842 23.185 15 24.0078 15C24.8249 15 25.4804 15.6751 25.4564 16.4918L25.1566 26.6844Z'
                fill='#FFFDFB'
            />
            <path
                d='M22.5 30.7414C22.5 31.5814 23.1686 32.25 23.9914 32.25C24.8314 32.25 25.5 31.5814 25.5 30.7414C25.5 29.9357 24.8314 29.25 23.9914 29.25C23.1686 29.25 22.5 29.9357 22.5 30.7414Z'
                fill='#FFFDFB'
            />
        </Icon>
    );
};

export default InfoIcon;
